import { render, staticRenderFns } from "./ResultSummaryBlock.vue?vue&type=template&id=1c53e5e6&scoped=true"
import script from "./ResultSummaryBlock.vue?vue&type=script&lang=js"
export * from "./ResultSummaryBlock.vue?vue&type=script&lang=js"
import style0 from "./ResultSummaryBlock.vue?vue&type=style&index=0&id=1c53e5e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c53e5e6",
  null
  
)

export default component.exports